import { useSyncExternalStore } from "react";

import { getWorkspacesSnapshot, subscribeWorkspaces } from "@/lib/stores/workspace-store";

// Reactive read of the workspace store. The snapshot is a frozen object replaced wholesale
// on every mutation (same caching contract as use-permissions), so it slots straight into
// useSyncExternalStore.
export function useWorkspaces() {
  return useSyncExternalStore(subscribeWorkspaces, getWorkspacesSnapshot, getWorkspacesSnapshot);
}
